import { PortalType } from '@studyportals/domain-client';
import { RouteLocationNormalized } from 'vue-router';
import { PortalDefinitionHelper } from '../../models/definition';
import { AttendanceFilterOptionValue } from '@studyportals/search-filters/server-side';
import { IRouteValidator } from './IRouteValidator';

export class DistanceLearningRouteValidator implements IRouteValidator {

	public isValid(to: RouteLocationNormalized): boolean {
		const portalDefinition = new PortalDefinitionHelper().getPortalDefinition(PortalType.DISTANCE_LEARNING);
		const isDistanceLearning = to.params.portal_type === portalDefinition.path;
		const isPrettyPathWithOnlineFilter = to.path.includes('distance-learning/online');

		if (!isDistanceLearning || isPrettyPathWithOnlineFilter) {
			return true;
		}

		return this.allDeliveryMethodOptionsValid(to) || this.hasDeliveryMethodFilter(to);
	}

	public applyValidationFix(to: RouteLocationNormalized): RouteLocationNormalized {
		to.query['mh'] = ['online', 'blended'];
		return to;
	}

	private allDeliveryMethodOptionsValid = (to: RouteLocationNormalized): boolean => {
		const mh = to.query.mh?.toString();
		if (!mh) {
			return false;
		}

		const options = mh.split(',');
		const result = options
			.map((value) => value as AttendanceFilterOptionValue === AttendanceFilterOptionValue.ONLINE || value as AttendanceFilterOptionValue === AttendanceFilterOptionValue.BLENDED)
			.reduce((current, next) => current && next);

		return result;
	};

	private hasDeliveryMethodFilter = (to: RouteLocationNormalized): boolean => {
		const search = to.query.search;
		if (!search) {
			return false;
		}

		return search.includes('mh-');
	};
}
